import { CustomerState } from "../state";
import { deleteFromLocalStorage } from "../../../../../utils";
import { LocalStorageKeys } from "../../../../../enums/local-storage-keys";

export const logoutCustomerReducer = (state: CustomerState) => {
  deleteFromLocalStorage(LocalStorageKeys.CUSTOMER_STATE);
  deleteFromLocalStorage(LocalStorageKeys.AUTH_TOKEN);
  deleteFromLocalStorage(LocalStorageKeys.SSE_TOKEN);

  state.authedId = null;
  state.authedSSE = false;
  state.registered = false;
  state.customer = null;
  state.authedId = null;
  state.loggedIn = false;
  state.isSubscriber = false;
  state.isVerified = false;
  state.hasPrescription = false;
  state.converted = false;
};
